import React from "react";

import { CellContainer, CellDate, CellLink, CellText, CellFetch } from "./components";
import { TableCellProps } from "./types";

interface TableCellComponent extends React.FC<TableCellProps> {
  Container: typeof CellContainer;
  Date: typeof CellDate;
  Link: typeof CellLink;
  Text: typeof CellText;
  Fetch: typeof CellFetch;
}



export const TableCell: TableCellComponent = ({ children }) => {
  return <>{children}</>;
};

TableCell.Container = CellContainer;
TableCell.Date = CellDate;
TableCell.Link = CellLink;
TableCell.Text = CellText;
TableCell.Fetch = CellFetch;
